<template>
    <v-menu
        v-model="mostrar"
        :close-on-content-click="false">
        <template
            v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                v-bind="attrs"
                v-on="on">
                <v-icon>
                    mdi-dots-vertical
                </v-icon>
            </v-btn>
        </template>
        <v-list nav dense>
          <v-list-item :to="{ name: 'auditoriaInformeObservaciones',
              params: { idInforme: auditoriaInforme.id }}">
              <v-list-item-icon>
                <v-icon>mdi-file-document-remove-outline</v-icon>
              </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Observaciones
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-chip small>
                {{ auditoriaInforme.observaciones.length }}
              </v-chip>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item
            v-if="mixValidaScopesActions(2)"
            @click="agregarObservacion"
            link>
            <v-list-item-icon>
              <v-icon>
                mdi-view-grid-plus-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Agregar Observación
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item :to="{ name: 'auditoriaInformeRespuestas',
            params: { idInforme: auditoriaInforme.id } }">
            <v-list-item-icon>
              <v-icon>mdi-file-document-arrow-right-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Respuestas
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-chip small>
                {{ auditoriaInforme.respuestas.length }}
              </v-chip>
            </v-list-item-icon>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item
          v-if="mixValidaScopesActions(2)"
            @click="editar"
            link>
            <v-list-item-icon>
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Editar
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
          v-if="mixValidaScopesActions(3)"
          @click="borrar"
            link>
            <v-list-item-icon>
              <v-icon>
                mdi-delete
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Eliminar
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!--
          <v-list-item
          v-if="mixValidaScopesActions(2)"
          :disabled="auditoriaInforme.dataFile && auditoriaInforme.dataFile !==''? false:true"
          @click="verPdf"
            link>
            <v-list-item-icon>
              <v-icon>
                mdi-file-pdf-box
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                VerPdf
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          -->
        </v-list>
    </v-menu>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'OpcionesListadoAuditoriasInformes',
  props: {
    auditoriaInforme: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrar: false,
    };
  },
  methods: {
    editar() {
      eventBus.$emit('editar-auditoria-informe', this.auditoriaInforme);
    },
    borrar() {
      eventBus.$emit('eliminar-auditoria-informe', this.auditoriaInforme);
    },
    agregarObservacion() {
      eventBus.$emit('agregar-auditoria-informe-observacion', this.auditoriaInforme);
    },
    verPdf() {
      eventBus.$emit('ver-pdf-informe', this.auditoriaInforme);
    },
  },
};
</script>
